import React from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale);

const GaugeChart = ({ value, isLeadTarget, generatedLeadsTarget, totalActivity }) => {
  const total = (value / generatedLeadsTarget) * 100;
  const isActivityProgress = isLeadTarget && value !== 0 ? total : value
  const data = {
    labels: ["Filled", "Remaining"],
    datasets: [
      {
        data: [isActivityProgress, 100 - isActivityProgress],
        backgroundColor: ["#36A2EB", "#E7E9ED"],
        hoverBackgroundColor: ["#36A2EB", "#E7E9ED"],
      },
    ],
  };

  const options = {
    rotation: -90,
    circumference: 180,
    cutout: "60%",
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
  };

  return (
    <div style={{ position: "relative", width: "350px", height: "305px" }}>
      <Doughnut data={data} options={options} />
      <div
        style={{
          position: "absolute",
          top: "20%",
          left: "43%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          fontSize: "24px",
        }}
      >
        {isLeadTarget && value === 0 ? 0 : parseFloat(isActivityProgress)?.toFixed(2)}%
      </div>
      <div
        style={{
          position: "absolute",
          bottom: `${isActivityProgress >= 50 ? "20%" : "15%"}`,
          left: `${isActivityProgress >= 50 ? "45%" : "40%"}`,
          transform: `translateX(-50%) rotate(${isActivityProgress * 1.8 - 90}deg)`,
        }}
      >
        <svg
          width="23"
          height="78"
          viewBox="0 0 23 108"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.0994 0.238045L20.7441 80.4145L3.25147 80.8276L10.0994 0.238045Z"
            fill="black"
          />
          <ellipse
            cx="11.5156"
            cy="82.6106"
            rx="9.34495"
            ry="9.71875"
            transform="rotate(90 11.5156 82.6106)"
            fill="#3862DD"
          />
        </svg>
      </div>
      <div
        style={{
          position: "absolute",
          bottom: "8%",
          right: `${isLeadTarget ? "-8%" : "3%"}`,
          transform: "translate(-50%, -50%)",
        }}
      >
        {isLeadTarget ? `Lead Target : ${generatedLeadsTarget}` : `Total : ${totalActivity}`}
      </div>
    </div>
  );
};

export default GaugeChart;
